/**************************************************************************************************/
/** @export Namespace @name VersionTracking                                                      **/
/**************************************************************************************************/
export namespace VersionTracking
{
	export const CurrentBuild = 2423
	export const CurrentVersion = '3.8.2.102'
}